// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module_container_2LYbD","menu-item":"index-module_menu-item_2MZ7W"};